"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

exports.__esModule = true;
exports.default = void 0;

var R = _interopRequireWildcard(require("ramda"));

var P = _interopRequireWildcard(require("@react-pdf/primitives"));

var isText = R.propEq('type', P.Text);
var _default = isText;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@react-pdf/render/lib/utils/isText.js
// module id = 223
// module chunks = 0